// ----------------------------------------------------------------------

export const HEADER = {
  H_MOBILE: 64,
  H_DESKTOP: 88,
  H_DESKTOP_OFFSET: 88 + 1,
};

export const NAV = {
  W_VERTICAL: 280,
  W_MINI: 120,
};
